<template>
  <div class="item-list">
    <div class="item-title">
      <span>{{dataList.title}}</span>
      <!-- <span class="title">《参观正在美术馆：既长知识又凉爽》</span>
      <span>已审核成功</span> -->
    </div>
    <div class="item-date">{{dataList.createTime}}</div>
  </div>
</template>

<script>
export default {
  name: "hotPost",
  props: ["dataList"],
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.item-list {
  width: 100%;
  min-height: 82px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 20px 0;
  border-bottom: 1px solid #efefef;
  .item-title {
    span {
      font-size: 16px;
      color: #121212;
    }
    .title {
      color: #317DFF;
    }
  }
  .item-date {
    font-size: 13px;
    font-weight: 400;
    color: #999999;
    margin-top: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ActiveNotice.vue